module.exports = __webpack_public_path__ + "static/media/bg-2.736b1712.png";